<template>
    <div class="GradeAnalysisSch_Compare" v-if="isEmpty"></div>
    <div class="GradeAnalysisSch_Compare" :id="`SchoolGradeComparison_${ParentId}`" v-else>

        <div class="GradeAnalysisSch_Compare_Content">
            <div class="GradeAnalysisSch_Compare_Title flex-align-center">{{ ParentData.report_name }}</div>
            <div class="Secondary_heading">
                <div class="vertical_grain_icon"></div> <span class="title">参与情况</span>
            </div>
            <div class="content">
                <!-- ParticipateInStatistics -->
                <Short_form_SchoolComparison :construction="Participation_TableStructure_G"
                    :tabledata="Participation_Data_G" :row_high="Participation_high_G">
                </Short_form_SchoolComparison>
                <div class="Participation_Chart">
                    <BarChart :InjectData="Participation_GraphicalData_G" :Id="'Participation_G1' + ParentId" Title="参与率（%）"
                        XAxis="examName" SeriesDataName="totalSignInPercent" ChartType="百分比"></BarChart>
                </div>
            </div>
            <div class="Secondary_heading">
                <div class="vertical_grain_icon"></div> <span class="title">书写习惯统计情况</span>
            </div>
            <div class="content">
                <!-- filteredGrippingPostureStatistics -->
                <Short_form_SchoolComparison :construction="GrippingPosture_TableStructure_G"
                    :tabledata="Participation_Data_G" :row_high="GrippingPosture_high_G">
                </Short_form_SchoolComparison>
                <div class="Participation_Chart">
                    <!-- filteredGrippingPostureStatistics.filter(item => ![3, 4, 5].includes(item.examType)) -->
                    <BarChart
                        :InjectData="Participation_GraphicalData_G"
                        :Id="'GrippingPosture_G2' + ParentId" Title="握笔姿势错误人数" XAxis="examName"
                        SeriesDataName="errHoldPercent" ChartType="百分比">
                    </BarChart>
                </div>
            </div>
            <div class="content">
                <!-- filteredSittingPostureStatistics -->
                <Short_form_SchoolComparison :construction="SittingPosture_TableStructure_G"
                    :tabledata="Participation_Data_G" :row_high="SittingPosture_high_G">
                </Short_form_SchoolComparison>
                <div class="Participation_Chart">
                    <!-- filteredSittingPostureStatistics.filter(item => ![3, 4, 5].includes(item.examType)) -->
                    <BarChart
                        :InjectData="Participation_GraphicalData_G"
                        :Id="'SittingPosture_G3' + ParentId" Title="坐姿错误人数" XAxis="examName" SeriesDataName="errSitPercent"
                        ChartType="百分比">
                    </BarChart>
                </div>
            </div>
            <div class="Secondary_heading">
                <div class="vertical_grain_icon"></div> <span class="title">等级分布情况</span>
            </div>
            <div class="content">
                <Short_form_SchoolComparison :construction="Distribution_TableStructure_G" :tabledata="Distribution_Data_G"
                    :row_high="Distribution_high_G">
                </Short_form_SchoolComparison>
                <div class="Participation_Chart">
                    <ComparativeColumnChart :InjectData="Distribution_GraphicalData_G" :Id="'Distribution_G4' + ParentId">
                    </ComparativeColumnChart>
                </div>
            </div>
            <div class="Secondary_heading">
                <div class="vertical_grain_icon"></div> <span class="title">单项成绩对比情况</span>
            </div>
            <div class="content">
                <Short_form_Customize :construction="Score_TableStructure_G" :tabledata="Score_Data_G"
                    :row_high="Score_high_G" Title="单项成绩对比">
                </Short_form_Customize>
                <div class="Participation_Chart HeightIncrease">
                    <ComparisonOfGrades_LineChart :InjectData="Score_GraphicalData_G" :Id="'Participation_G5' + ParentId">
                    </ComparisonOfGrades_LineChart>
                </div>
            </div>
            <div class="Secondary_heading">
                <div class="vertical_grain_icon"></div> <span class="title">各维度等级人数统计</span>
            </div>
            <div class="content">
                <div class="QuadrantDiagram" v-if="Score_Data_G">
                    <div class="grid-item HeightIncreasegrid" v-for="(item, index) in Score_TableStructure_Type"
                        :key="index">
                        <div class="grid-item_title">{{ scoreFields[item.fieldName] }}</div>
                        <DimensionalColumnChart :InjectData="Score_GraphicalData_G" :type="item"
                            :Id="'Distribution_G6' + item.fieldName + ParentId" v-if="Score_GraphicalData_G">
                        </DimensionalColumnChart>
                    </div>
                </div>
            </div>
            <div class="Secondary_heading">
                <div class="vertical_grain_icon"></div> <span class="title">各班优良率情况</span>
            </div>
            <div class="content">
                <Short_form_Customize_ExcellentRate :construction="ExcellentRate_TableStructure_G"
                    :tabledata="ExcellentRate_Data_G" :row_high="ExcellentRate_high_G" Title="各班优良率">
                </Short_form_Customize_ExcellentRate>
            </div>
            <div class="Secondary_heading">
                <div class="vertical_grain_icon"></div> <span class="title">{{ ParentData.gradeText }}象限分布对比情况</span>
            </div>
            <div class="content">
                <div class="QuadrantDiagram" v-if="QuadrantDiagramData && QuadrantDiagramData.length > 0">
                    <div class="grid-item" v-for="(item, index) in QuadrantDiagramData" :key="index">
                        <FourSymbolsLineDiagram_Single :id_type="index + 'CompareGather' + ParentId" :ownexamData="item"  :GradeValue="ParentData.grade"
                            v-if="item && item.length > 0">
                        </FourSymbolsLineDiagram_Single>
                    </div>
                </div>
            </div>
            <div class="Secondary_heading">
                <div class="vertical_grain_icon"></div> <span class="title">未分级学生</span>
            </div>
            <div class="content">
                <div class="ReviewForm UngradedStudents_wrap">
                    <table class="DimensionRating_table UngradedStudents_table">
                        <thead>
                            <tr>
                                <th class="ReviewForm_table_type">分类</th>
                                <th class="ReviewForm_table_Person">人数</th>
                                <th>学生名单</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-if="ungradedStudentsList.length > 0">
                                <td>未分级</td>
                                <td>{{ ungradedStudentsList.length }}</td>
                                <td class="UngradedStudents_names">
                                    <div class="UngradedStudents_names_inner">
                                        <span v-for="(grp, gIdx) in ungradedGroupedList" :key="grp.className"
                                            class="UngradedStudents_class_block">
                                            <span class="UngradedStudents_class_label">{{ grp.className }}：</span>
                                            <span v-for="(stu, sIdx) in grp.students" :key="stu.user_id">
                                                <span class="UngradedStudents_name_link"
                                                    @click="JumpToPersonalReport(stu.user_id, stu.name)">{{ stu.name
                                                    }}</span>
                                                <span v-if="sIdx < grp.students.length - 1">、</span>
                                            </span>
                                            <span v-if="gIdx < ungradedGroupedList.length - 1"
                                                class="UngradedStudents_between_classes">&nbsp;</span>
                                        </span>
                                    </div>
                                </td>
                            </tr>
                            <tr v-else>
                                <td colspan="3" class="UngradedStudents_empty">暂无未分级学生</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="Secondary_heading flex-align-between" v-if="!isAllFormDataEmpty">
                <div class="flex-align">
                    <div class="vertical_grain_icon"></div><span class="title">学生分级点评</span>
                </div>
                <div class="ClassificationTypeDescription flex-align" role="button" tabindex="0"
                    @click="classificationTypeDialogVisible = true"
                    @keyup.enter="classificationTypeDialogVisible = true">
                    <span class="title"><i class="el-icon-info"></i>分级类型说明</span>
                </div>
            </div>
            <div class="content" v-if="!isAllFormDataEmpty">
                <div class="ReviewForm">
                    <table class="DimensionRating_table">
                        <thead>
                            <tr>
                                <th class="ReviewForm_table_type">分类</th>
                                <th class="ReviewForm_table_Person">人数</th>
                                <th>学生名单</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(value, key) in nonEmptyFormData" :key="key">
                                <td>{{ key }}</td>
                                <td>{{ value.length }}</td>
                                <!-- <td>
                                    <span class="List" v-for="(itemSon, indexSon) in value"
                                        @click="JumpToPersonalReport(itemSon.user_id, itemSon.name)">
                                        {{ itemSon.name }}
                                    </span>
                                </td> -->
                                <td v-Grouping="{ value: value }">


                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="content" v-if="!isAllFormDataEmpty">
                <div class="SummaryAndSuggestions">总结与建议</div>
                <p class="SummaryAndSuggestions_text">
                    本年级学生整体呈现多元发展的态势，其中超过{{ positiveStudentPercentage
                    }}%的学生(双优型、稳定进步型、努力显著进步型)表现积极或持续进步，体现了班级良好的学习氛围;部分学生(天赋退步型、波动型、需关注型)需要更多关注和帮助，相信通过针对性指导，每个同学都能发挥出自己的潜力!
                </p>
                <div class="SuggestedCategory" v-if="syTypeNum > 0">· 双优型(第一象限稳定)({{ syTypeNum }}人)</div>
                <p class="SummaryAndSuggestions_text" v-if="syTypeNum > 0">
                    {{ syTypeNum }}名学生表现出色且稳定，持续位于综合评价的第一象限。这些学生具备良好的学习习惯与扎实的基础能力，是班级学习的引领者。该类型学生常见问题与建议：
                    1、多横、多竖的间距偶尔有细微偏差，破坏了笔画排布的视觉均匀感，导致字的整体书写秩序感不够稳定；建议开展精细控笔训练，重点提升笔画书写质感与位置精细度，尤其强化多画等距不同间距精度；针对书写不足制定专项训练计划：若起收细节不到位导致间距精度偏差，则集中练习其收笔力度与位置控制；若多笔画交叉拥挤，重点练习交叉笔画间距分配。​
                    2、部分笔画过于拥挤或放得太开，对收放的把控不够精准，无法让笔画形成疏密的排布节奏，字体略显呆板。建议书写前认真观察笔画位置关系、呼应形态、长度比例及疏密层次，将书写规律深度内化，同时针对细节问题不断调整，让手部形成肌肉记忆、大脑养成书写规律意识，为未来快速书写夯实基础；通过持续优化，让大脑养成符合书写规律的疏密排布意识。
                </p>
                <div class="SuggestedCategory" v-if="wdjTypeNum > 0">· 稳健型({{ wdjTypeNum }}人)</div>
                <p class="SummaryAndSuggestions_text" v-if="wdjTypeNum > 0">
                    {{ wdjTypeNum
                    }}名学生呈现出持续稳定的进步态势，两次测评间保持正向发展。这类学生的特点是：脚踏实地、循序渐进、抗挫折能力较强。他们通过自身的坚持与努力，正在逐步释放学习潜力，是班级中积极向上的中坚力量。该类型学生常见问题与建议：
                    1、部分字出现字的重心偏移的现象；建议加强对重心维度的理解，利用田字格的横中线和竖中线，建立字的中心轴，从而让字均衡平稳。
                    2、多画的间距，逐渐均匀但经细致还需要提升；建议加强控笔练习，提升笔画精细度，让笔画间距均匀稳定。
                    3、笔画位置关系相对准确，但偶尔会出现顾此失彼；建议写前认真观察，注意留心笔画位置关系，笔画间的呼应和主次的层次关系。
                    4、收放长短对比清晰，空间疏密的细节需要提升。建议书写前认真观察，字的疏密区域，根据书写规律布局笔画。
                </p>
                <div class="SuggestedCategory" v-if="nljTypeNum > 0">· 进取型({{ nljTypeNum }}人)</div>
                <p class="SummaryAndSuggestions_text" v-if="nljTypeNum > 0">
                    这部分学生在努力维度表现突出，进步幅度显著，体现了"勤能补拙"的可贵品质。他们学习态度积极、意志坚定，需要关注的是帮助他们优化学习方法，提升学习效率。该类型学生常见问题与建议：
                    1、复合字穿插避让不够准确，各部之间宽窄长短比例略有偏差，以及间距忽大忽小，衔接不自然。建议书写前认真观察，并牢记部首书写规律，前期可以在田字格内，用铅笔轻轻画分部部件间的位置关系，书写时注意避让，遵循左部右侧笔画紧收让右，右部左侧笔画紧收让左；
                    2、占格居中不稳定，出现过大过小以及占格偏斜等问题。建议书写前认真观察字上下左右的笔画与格的间距，以及主笔和中心笔画。辅助定位，逐步调整字与格的关系，做到占位居中，大小一致。
                    3、多画等距不稳定，笔画需平行且间距视觉侧面均等。建议加强控笔练习，通过手腕手指的灵活练习，逐步提升笔画间距的一致性；
                    4、大部分字的重心都趋于稳定，但仍有个别字的重心出现失衡现象。建议在做到横平竖直的同时，可以通过田字格的横中心和竖中线，辅助建立字的中心轴，让复合字可以上下对正，且左右对称或均衡。
                </p>
                <div class="SuggestedCategory" v-if="qnxTypeNum > 0">· 潜能型({{ qnxTypeNum }}人)</div>
                <p class="SummaryAndSuggestions_text" v-if="qnxTypeNum > 0">
                    {{ qnxTypeNum
                    }}名学生在纵向维度出现暂时性波动，是充满潜力的学生，表现虽有波动，但这正说明有很大的提升空间！每次变化都是宝贵的经验，学会从波动中寻找规律，一起找到最适合的学习节奏！该类型学生常见问题与建议：
                    书写中会有些不稳定，如练 “居中” 时就顾不上 “重心”，练 “重心”
                    时笔画又写歪；换着练不同的字时，笔画角度（比如撇捺的倾斜度）、用力大小会变，不稳定；调整部首和部件的组合时，笔画位置总是找不着的问题，这是的几个建议：
                    1、字中心偏离田字格交点，占格过大；建议写每个字前，标记字的中心笔画和田字格交点，每天练12个字；写完后观察田字格边框与字四周笔画的位置关系，尽量让上下间距一致，左右距离均等，保证字在格子里不偏左也不偏右。
                    2、收放把控要么收得太紧，要么放得太开；建议寻找主笔和舒展的笔画，进行主次笔长短对比，以及字疏密布局的观察，默念书写规律后在下笔。
                    3、多画间距有些不一致，过大或多小；建议加强控笔练习，书写时注意笔画间距一致，且笔画之间保持平行，角度变化也会导致等距视觉的均衡感的缺失。
                    4、部件之间间距把握不太准确，穿插避让不到位。建议书写前先默念部首规律，划分部件之间的区域，遵循左部右侧紧收让右，右侧左部紧收让左，上部下方近齐让下，下方上部笔画缩短避让。并根据组合规律每天临写练习8个字，纠正偏差。
                </p>
                <div class="SuggestedCategory" v-if="bdTypeNum > 0">· 波动型({{ bdTypeNum }}人)</div>
                <p class="SummaryAndSuggestions_text" v-if="bdTypeNum > 0">
                    {{ bdTypeNum
                    }}名学生的表现存在较大波动性，反映出状态不稳定、学习方法待优化等特点。这种波动既可能是挑战也是机遇，说明他们具有很强的可塑性。需要加强学习习惯培养和心理疏导，帮助其建立稳定的学习节奏。该类型学生常见问题与建议：
                    书写中会有些不稳定，如练 “居中” 时就顾不上 “重心”，练 “重心”
                    时笔画又写歪；换着练不同的字时，笔画角度（比如撇捺的倾斜度）、用力大小会变，不稳定；调整部首和部件的组合时，笔画位置总是找不着的问题，这是的几个建议：
                    1、首先要养成观察习惯，找准中心笔画和四周笔画，确定字与格子的位置关系，稳定居中占格；
                    2、要加强控笔练习，提升等距维度好的同时，养成书横平竖直的书写习惯，解决大部分重心问题；
                    3、还要熟记部首书写规律，在书写复合字时做到，相互避让，左让右，上让下。半包围留空小，全包围留空隙的组合习惯。当以上问题稳定后再逐一解决其它维度，让书写逐步稳定提升。
                </p>
                <div class="SuggestedCategory" v-if="xgzTypeNum > 0">· 重点型({{ xgzTypeNum }}人)</div>
                <p class="SummaryAndSuggestions_text" v-if="xgzTypeNum > 0">
                    {{ xgzTypeNum
                    }}名学生目前在学习和成长方面面临较大挑战，需要教师和家长的特别关注。这些学生正处于发展的关键期，相信通过针对性帮助，他们一定能找到适合自己的成长路径。该类型学生常见问题与建议：
                    1、可以通过一些小技巧来让书写变得简单起来。例如可以在田字格内侧贴一圈细胶带（当“边界线”），书写时确保笔画不碰到胶带，每天练15个字；一起练习通关占格这个小挑战。
                    2、笔画微斜，有可能是姿势不正确呦！在练习控笔前，先调整正确的双姿，做到发力正确，练习手腕手指协调性，这时候书写中的横平竖直，和转折清晰就变得很简单了！
                    3、要是觉得写字没头绪，不知道如何收放，可以玩 “找主笔” 的小把戏！试着让主笔 “冒出头” 更显眼，笔画之间也像搭积木似的有顺序，每天练 20 个笔画，慢慢就会发现，写字越来越顺啦！
                </p>
                <div class="SuggestedCategory" v-if="tfxTypeNum > 0">· 天赋型({{ tfxTypeNum }}人)</div>
                <p class="SummaryAndSuggestions_text" v-if="tfxTypeNum > 0">
                    {{ tfxTypeNum }}名学生在书法学习上具备突出天赋与领悟力，在结构观察、重心把控、主笔理解等方面展现出明显优势，但在细节精度与复杂字形处理上仍需通过持续练习加以夯实。该类型学生常见问题与建议：
                    1、对角度变化类笔画的细节把握不足，影响撇、点等多画等距的精细表现，同一字内不同位置间距细节存在偏差；建议加强多角度笔画控笔训练，细化等距规律观察，针对性提升不同笔画组合的间距均匀度与细节表现力。
                    2、复合字内部组合关系理解不够深入，导致收放疏密层次表现不足；建议系统学习复合字组合规律，强化疏密对比意识，在书写中合理规划空间布局，提升整体节奏感。
                    3、复杂复合字的笔画位置与书写规律把握不够精准，易出现大小不当、占格不居中问题；建议深化观察方法训练，拆解复杂字形结构，精准定位笔画关系，确保无论简单或复杂字均能大小适中、居中规范。
                </p>
            </div>
        </div>

        <el-dialog title="分级类型说明" :visible.sync="classificationTypeDialogVisible" width="600px" top="0"
            append-to-body custom-class="grade-classification-type-dialog">
            <ol class="classification-type-desc-list">
                <li><strong>重点型</strong>：书写能力长期偏弱、明显退步或低位徘徊，是重点关注与帮扶的对象。</li>
                <li><strong>波动型</strong>：书写表现忽高忽低、波动剧烈，缺乏稳定规律。</li>
                <li><strong>天赋型</strong>：纵向维度天赋突出，整体尚未转化为稳定的优秀表现。</li>
                <li><strong>双优型</strong>：双维度均正向提升，表现稳定且处于优秀水平。</li>
                <li><strong>进取型</strong>：通过持续努力稳步进步，从低位向中上游迈进。</li>
                <li><strong>稳健型</strong>：表现平稳无剧烈波动，是未被归类为特殊形态的基础稳健类型。</li>
                <li><strong>潜能型</strong>：偶有高峰表现，具备可挖掘的成长潜力。</li>
            </ol>
            <p class="classification-type-desc-note">注：需满足完成4次及以上测评，才能进行书写趋势分析与分级。</p>
        </el-dialog>
    </div>
</template>

<script>
import Short_form_SchoolComparison from '../appraisalCharts/Short_form_SchoolComparison.vue'
import Short_form_Customize from '../appraisalCharts/Short_form_Customize.vue'
import Short_form_Customize_ExcellentRate from '../appraisalCharts/Short_form_Customize_ExcellentRate.vue'
import BarChart from './HistoricalComparisonBarChart.vue'
import ComparisonOfGrades_LineChart from './ComparisonOfGrades_LineChart.vue'
import ComparativeColumnChart from './ComparativeColumnChart.vue'
import DimensionalColumnChart from './DimensionalColumnChart.vue'
import FourSymbolsLineDiagram_Single from '../../report/FourSymbolsLineDiagram_Single.vue'
import { lookupGradeK0 } from '../../report/quadrantGradeAxis.js'
import axios from 'axios';

/**
 * 学校年级「多测评对比」报告页。
 *
 * 数据流概览：
 * 1. initAllMethods：依次请求参与情况、等级分布、单项成绩、各班优良率、矩阵散点坐标、未分级学生；
 *    中途 LevelDistributionScreening 根据 Filtervalue 决定全量或筛选后的展示数据。
 * 2. 矩阵有散点时 getStudentLevelRatioCompare：拉取学生能力记录，与 QuadrantDiagramData 按 user_id 合并后 TypeGrouping。
 * 3. TypeGrouping：统计四象限落点次数 → 按优先级规则打标签 → 汇总 formData 与积极学生占比。
 */
export default {
    components: {
        Short_form_SchoolComparison,
        Short_form_Customize,
        Short_form_Customize_ExcellentRate,
        BarChart,
        ComparisonOfGrades_LineChart,
        ComparativeColumnChart,
        DimensionalColumnChart,
        FourSymbolsLineDiagram_Single

    },
    props: ['ParentId', 'ParentData', 'Filterdata', 'Filtervalue', 'ParticipateInStatistics', 'GrippingPostureStatistics', 'SittingPostureStatistics', 'factorMap'],
    data() {
        return {
            isEmpty: false,
            //参与情况表结构
            Participation_TableStructure_G: [
                {
                    fieldName: 'examName',
                    title: '测评'
                },
                {
                    fieldName: 'totalSign',
                    title: '注册人数（人）'
                },
                {
                    fieldName: 'totalSignIn',
                    title: '参与总人数（人）'
                },
                {
                    fieldName: 'totalSignInPercent',
                    title: '参与率（%）'
                },
            ],
            Participation_Data_G: null,
            Participation_GraphicalData_G: null,
            Participation_high_G: '21',
            //书写习惯表结构（握姿）
            GrippingPosture_TableStructure_G: [
                {
                    fieldName: 'examName',
                    title: '测评'
                },
                {
                    fieldName: 'errHold',
                    title: '握笔姿势错误人数（人）'
                },
                {
                    fieldName: 'errHoldPercent',
                    title: '错误比例（%）'
                },
            ],
            GrippingPosture_high_G: '21',
            //书写习惯表结构（坐姿）
            SittingPosture_TableStructure_G: [
                {
                    fieldName: 'examName',
                    title: '测评'
                },
                {
                    fieldName: 'errSit',
                    title: '坐姿错误人数（人）'
                },
                {
                    fieldName: 'errSitPercent',
                    title: '错误比例（%）'
                },
            ],
            SittingPosture_high_G: '21',
            //等级分布表结构
            Distribution_TableStructure_G: [
                {
                    fieldName: 'name',
                    title: '测评'
                },
                {
                    fieldName: 'good_count',
                    title: '优秀'
                },
                {
                    fieldName: 'qualified_count',
                    title: '良好'
                },
                {
                    fieldName: 'couhe',
                    title: '合格'
                },
                {
                    fieldName: 'need_improvement_count',
                    title: '待提升'
                },
                {
                    fieldName: 'count',
                    title: '总计'
                },
                {
                    fieldName: 'good_ratio',
                    title: '优良率（%）'
                },
                {
                    fieldName: 'qualified_ratio',
                    title: '合格率（%）'
                },
                {
                    fieldName: 'need_improvement_ratio',
                    title: '待提升率（%）'
                },
            ],
            Distribution_Data_G: null,
            Distribution_GraphicalData_G: null,
            Distribution_high_G: '21',
            // 单项成绩对比表结构（首列为测评名，后续为各维度）
            Score_TableStructure_Type: [],
            Score_TableStructure_G: [
                {
                    fieldName: 'name',
                    title: '测评'
                },
                {
                    fieldName: 'center_pos',
                    title: '居中占位'
                },
                {
                    fieldName: 'grid_size',
                    title: '占格大小'
                },
                {
                    fieldName: 'glyph_grav',
                    title: '字形重心'
                },
                {
                    fieldName: 'combo_rel',
                    title: '组合关系'
                },
                {
                    fieldName: 'rewind_rel',
                    title: '收放关系'
                },
                {
                    fieldName: 'multi_dist',
                    title: '多画等距'
                },
                {
                    fieldName: 'stroke_rel',
                    title: '笔画关系'
                },
                {
                    fieldName: 'integrity',
                    title: '作品完整度'
                },
            ],
            Score_Data_G: null,
            Score_GraphicalData_G: null,
            Score_high_G: '21',
            //各班优良率
            ExcellentRate_TableStructure_G: [],
            ExcellentRate_Data_G: null,
            ExcellentRate_high_G: '21',
            QuadrantDiagramData: [],
            //学生分级点评
            formData: {},
            // 未分级学生（接口返回数组）
            UngradedStudents: [],
            syTypeNum: 0,
            wdjTypeNum: 0,
            nljTypeNum: 0,
            qnxTypeNum: 0,
            bdTypeNum: 0,
            xgzTypeNum: 0,
            tfxTypeNum: 0,
            positiveStudentCount: 0, //双优型、稳健型、进取型总数
            positiveStudentPercentage: 0, //双优型、稳健型、进取型百分比
            isAllFormDataEmpty: true,
            classificationTypeDialogVisible: false,
            /** 接口原始缓存（供 LevelDistributionScreening 全量/筛选） */
            ParticipationStatusStorage: [],
            originalDistributionData: null,
            IndividualEventResult: null,
            ExcellentRateOfEachClass: null,
            /** 矩阵散点原始列表（按测评 keyvalue 一条记录一个学生点） */
            MatrixDistributionComparison: null,
            scoreFields: {
                'center_pos': '居中占位',
                'grid_size': '占格大小',
                'glyph_grav': '字形重心',
                'combo_rel': '组合关系',
                'rewind_rel': '收放关系',
                'multi_dist': '多画等距',
                'stroke_rel': '笔画关系',
                'integrity': '作品完整度'
            }
        };
    },
    /** 学生名单列：按班级分组渲染可点击姓名（innerHTML + 事件委托式绑定） */
    directives: {
        Grouping: {
            inserted: function (el, binding, vnode) {
                const vocabulary = binding.value.value;
                // 按 class_name 分组
                const groupedByClass = {};
                vocabulary.forEach(student => {
                    const className = student.class_name || '未分组';
                    if (!groupedByClass[className]) {
                        groupedByClass[className] = [];
                    }
                    // 将学生信息存储，包含姓名和ID
                    groupedByClass[className].push({
                        name: student.name,
                        id: student.user_id || student.id
                    });
                });

                // 构建显示内容：一年级一班：A学生、B学生（每个学生可点击）
                const result = [];
                for (const className in groupedByClass) {
                    const students = groupedByClass[className];
                    const studentsWithLinks = students.map(student => {
                        return `<span class="student-link" data-user-id="${student.id}" data-user-name="${student.name}" style="color: #0070d9; text-decoration: underline; cursor: pointer; margin-right: 10px;">${student.name}</span>`;
                    });
                    result.push(`${className}：${studentsWithLinks.join('、')}`);
                }

                el.innerHTML = result.join(' ');

                // 添加点击事件监听器
                const studentLinks = el.querySelectorAll('.student-link');
                studentLinks.forEach(link => {
                    link.addEventListener('click', function () {
                        const userId = this.getAttribute('data-user-id');
                        const userName = this.getAttribute('data-user-name');
                        // 调用父组件中的跳转方法
                        vnode.context.JumpToPersonalReport(userId, userName);
                    });
                });
            }
        }
    },
    computed: {
        nonEmptyFormData() {
            const result = {};
            for (const [key, value] of Object.entries(this.formData)) {
                if (value.length > 0) {
                    result[key] = value;
                }
            }
            return result;
        },

        filteredGrippingPostureStatistics() {
            if (!this.GrippingPostureStatistics || !Array.isArray(this.GrippingPostureStatistics)) {
                return [];
            }
            return this.GrippingPostureStatistics.map(item => {
                const newItem = { ...item };
                if ([3, 4, 5].includes(newItem.examType)) {
                    newItem.errHold = '/';
                    newItem.errHoldPercent = '/';
                }
                return newItem;
            });
        },
        filteredSittingPostureStatistics() {
            if (!this.SittingPostureStatistics || !Array.isArray(this.SittingPostureStatistics)) {
                return [];
            }
            return this.SittingPostureStatistics.map(item => {
                const newItem = { ...item };
                if ([3, 4, 5].includes(newItem.examType)) {
                    newItem.errSit = '/';
                    newItem.errSitPercent = '/';
                }
                return newItem;
            });
        },
        /** 未分级学生列表（保证为数组） */
        ungradedStudentsList() {
            return Array.isArray(this.UngradedStudents) ? this.UngradedStudents : [];
        },
        /** 按 class_name 分组，班级名排序，供「学生名单」列展示 */
        ungradedGroupedList() {
            const list = this.ungradedStudentsList;
            const map = {};
            list.forEach(s => {
                const cn = (s && s.class_name) ? s.class_name : '未分组';
                if (!map[cn]) map[cn] = [];
                map[cn].push(s);
            });
            return Object.keys(map).sort().map(k => ({ className: k, students: map[k] }));
        }

    },
    watch: {
        /** 学期/年级报告切换时整页重拉 */
        ParentData: {
            handler(newVal, oldVal) {
                if (newVal !== oldVal) {
                    this.initAllMethods();
                }
            },
            deep: true,
            immediate: false
        }
    },
    methods: {
        /** 入口：按顺序拉取各块数据，再筛表、再算学生分级 */
        async initAllMethods() {
            console.log('ParentData',this.ParentData);
            
            try {
                await this.getSchoolParticipation();
                await this.getDistribution();
                await this.getIndividualEventResult();
                await this.getClassLevelGoodList();
                await this.getschoolexamvaluexy();
                this.LevelDistributionScreening();
                await this.getStudentLevelRatioCompare();
                await this.UngradedStudentsRequest();
            } catch (error) {
                console.error("Error fetching data in order:", error);
            }
        },
        /** 卸载前清理子图表可能挂在 DOM 上的 echarts 残留 */
        destroyEchartsInstances() {
            this.$nextTick(() => {
                const chartIds = [
                    'Participation_G1' + this.ParentId,
                    'GrippingPosture_G2' + this.ParentId,
                    'SittingPosture_G3' + this.ParentId,
                    'Distribution_G4' + this.ParentId,
                    'Participation_G5' + this.ParentId,
                    ...this.Score_TableStructure_Type.map((item) =>
                        'Distribution_G6' + item.fieldName + this.ParentId),
                    ...Array.from({ length: 10 }, (_, i) => i + 'CompareGather' + this.ParentId)
                ];

                chartIds.forEach(id => {
                    const element = document.getElementById(id);
                    if (element) {
                        if (element.echartsInstance) {
                            if (typeof element.echartsInstance.dispose === 'function') {
                                try {
                                    element.echartsInstance.dispose();
                                } catch (e) {
                                    console.warn('Error disposing chart instance:', e);
                                }
                            }
                            delete element.echartsInstance;
                        }
                        if (element.innerHTML) {
                            element.innerHTML = '';
                        }
                    }
                });
            });
        },
        /** 参与情况（空数据时通知父级 EmptyData） */
        async getSchoolParticipation() {
            let data = {
                schoolId: this.$route.query.schoolId,
                termId: this.ParentData.term_id,
            }

            try {
                const resData = await this.$Api.Report.getSchoolParticipation(data);

                if (Array.isArray(resData) && resData.length > 0) {
                    this.ParticipationStatusStorage = resData;
                    this.isEmpty = false;
                } else {
                    this.ParticipationStatusStorage = [];
                    this.isEmpty = true;
                    this.$emit('EmptyData', { termId: this.ParentData.term_id });
                }
            } catch (error) {

            }
        },
        /** 本学期学校等级分布；比例字段转为百分比数值 */
        async getDistribution() {
            const url = `https://spark.deploy.lezhireading.com/statistics/static/results/valuebyschooltermnew/${this.$route.query.schoolId}/${this.ParentData.term_id}`;
            try {
                const response = await axios.get(url, {
                    params: { noCache: Date.now() },
                    timeout: 50000,
                    headers: { 'Accept': 'application/json' }
                });
                if (response.data.data) {
                    this.originalDistributionData = response.data.data;
                    this.originalDistributionData = this.originalDistributionData.map(item => {
                        const filterItem = this.Filterdata.find(filter => filter.keyvalue === item.keyvalue);
                        return {
                            ...item,
                            name: filterItem ? filterItem.examName : item.name,
                            good_ratio: parseFloat((item.good_ratio * 100).toFixed(2)),
                            qualified_ratio: parseFloat((item.qualified_ratio * 100).toFixed(2)),
                            need_improvement_ratio: parseFloat((item.need_improvement_ratio * 100).toFixed(2))
                        };
                    });
                } else {
                    this.originalDistributionData = [];
                    this.Distribution_Data_G = [];
                    this.Distribution_GraphicalData_G = [];
                }
            } catch (error) {
                console.error(error);
            }
        },
        async getIndividualEventResult() {
            const url = `https://spark.deploy.lezhireading.com/statistics/static/results/valueAll/${this.$route.query.schoolId}/${this.ParentData.term_id}`;
            try {
                const response = await axios.get(url, {
                    params: { noCache: Date.now() },
                    timeout: 50000,
                    headers: { 'Accept': 'application/json' }
                });
                const raw = response.data && response.data.data;
                if (!Array.isArray(raw)) {
                    this.IndividualEventResult = [];
                } else {
                    this.IndividualEventResult = raw.map(item => {
                        const filterItem = this.Filterdata.find(filter => filter.keyvalue === item.keyvalue);
                        return {
                            ...item,
                            name: filterItem ? filterItem.examName : item.name,
                        };
                    });
                }
            } catch (error) {
                console.error(error);
            }
        },
        async getClassLevelGoodList() {
            const url = `https://spark.deploy.lezhireading.com/statistics/static/results/schoolgoodratio/${this.$route.query.schoolId}/${this.ParentData.term_id}`;
            try {
                const response = await axios.get(url, {
                    params: { noCache: Date.now() },
                    timeout: 50000,
                    headers: { 'Accept': 'application/json' }
                });
                const rawGood = response.data && response.data.data;
                if (!Array.isArray(rawGood)) {
                    this.ExcellentRateOfEachClass = [];
                } else {
                    this.ExcellentRateOfEachClass = rawGood.map(item => ({
                        ...item,
                        good_ratio: parseFloat((item.good_ratio * 100).toFixed(2)) + '%'
                    }));
                }
                this.ExcellentRateHelper(this.ExcellentRateOfEachClass);
            } catch (error) {
                console.error(error);
            }
        },
        /** 由原始行数据生成各班 × 各测评优良率表头与单元格 */
        ExcellentRateHelper(data) {
            const apiData = Array.isArray(data) ? data : [];
            // 使用Map优化去重操作，获取唯一班级列表
            const classMap = new Map();
            const testMap = new Map();

            apiData.forEach(item => {
                // 避免重复添加班级信息
                if (!classMap.has(item.class_id)) {
                    classMap.set(item.class_id, {
                        class_id: item.class_id,
                        class_name: item.class_name
                    });
                }

                // 避免重复添加测试信息
                if (!testMap.has(item.keyvalue)) {
                    testMap.set(item.keyvalue, {
                        test_id: item.keyvalue,
                        name: item.keyvalue
                    });
                }
            });

            const uniqueClasses = Array.from(classMap.values());
            const uniqueTests = Array.from(testMap.values()).map(test => {
                // 根据Filterdata查找对应的考试名称
                const filterItem = this.Filterdata.find(filter => filter.keyvalue === test.test_id);
                return {
                    ...test,
                    name: filterItem ? filterItem.examName : test.name
                };
            });

            // 构建表结构
            const newTableStructure = [
                {
                    fieldName: 'class_name',
                    title: '班级'
                },
                ...uniqueTests.map(test => ({
                    fieldName: `test_${test.test_id}`,
                    title: test.name,
                    keyvalue: test.test_id
                }))
            ];

            this.ExcellentRate_TableStructure_G = newTableStructure;

            // 构建以class_id和test_id为键的快速查找映射
            const dataMap = new Map();
            apiData.forEach(item => {
                const key = `${item.class_id}_${item.keyvalue}`;
                dataMap.set(key, item.good_ratio);
            });

            // 构建表格数据
            const tableData = uniqueClasses.map(classItem => {
                const rowData = {
                    class_name: classItem.class_name,
                    class_id: classItem.class_id
                };

                // 为每个测试查找对应的优良率
                uniqueTests.forEach(test => {
                    const mapKey = `${classItem.class_id}_${test.test_id}`;
                    rowData[`test_${test.test_id}`] = dataMap.has(mapKey) ? dataMap.get(mapKey) : '-';
                });

                return rowData;
            });

            this.ExcellentRate_Data_G = tableData;
        },

        /** 矩阵散点：各测评下学生 (x,y)，已用 Filterdata 补全试卷名称 */
        async getschoolexamvaluexy() {
            const url = `https://spark.deploy.lezhireading.com/statistics/static/results/schoolexamvaluexy/${this.$route.query.schoolId}/${this.ParentData.term_id}`;
            try {
                const response = await axios.get(url, {
                    params: { noCache: Date.now() },
                    timeout: 50000,
                    headers: { 'Accept': 'application/json' }
                });
                const rawMatrix = response.data && response.data.data;
                this.MatrixDistributionComparison = Array.isArray(rawMatrix)
                    ? rawMatrix.map(item => {
                        const filterItem = this.Filterdata.find(filter => filter.keyvalue === item.keyvalue);
                        return {
                            ...item,
                            name: filterItem ? filterItem.examName : item.name || ''
                        };
                    })
                    : [];
            } catch (error) {
                console.error(error);
            }
        },
        /** 按测评 keyvalue 分组，供四象限图组件每组一条散点序列。x、y 已乘本年级系数。 */
        groupDataByTestId(data) {
            const groupedData = new Map();
            if (!Array.isArray(data)) {
                return [];
            }
            const grade = this.ParentData && this.ParentData.grade;
            const k0 = lookupGradeK0(this.factorMap, grade);
            data.forEach((item) => {
                if (!groupedData.has(item.keyvalue)) {
                    groupedData.set(item.keyvalue, []);
                }
                const x = Number(item.x);
                const y = Number(item.y);
                groupedData.get(item.keyvalue).push({
                    keyvalue: item.keyvalue,
                    exam_name: item.name,
                    user_id: item.user_id,
                    user_name: item.username,
                    school_id: item.school_id,
                    x: Number.isNaN(x) ? item.x : x * k0,
                    y: Number.isNaN(y) ? item.y : y * k0
                });
            });
            return Array.from(groupedData.values());
        },

        /** 学生能力类型与矩阵散点合并后，执行分级点评 */
        async getStudentLevelRatioCompare() {
            const url = `https://spark.deploy.lezhireading.com/statistics/static/results/owntypebyschool/${this.$route.query.schoolId}/${this.ParentData.term_id}`;

            try {
                const response = await axios.get(url, {
                    params: { noCache: Date.now() },
                    timeout: 50000,
                    headers: { 'Accept': 'application/json' }
                });

                const PersonalAbilityRecord = response.data.data;

                if (!Array.isArray(PersonalAbilityRecord)) {
                    return;
                }

                if (!Array.isArray(this.QuadrantDiagramData)) {
                    this.QuadrantDiagramData = [];
                }
                /** 按 user_id 汇总 QuadrantDiagramData 中多场测评散点 */
                const testMap = {};
                (this.QuadrantDiagramData || []).forEach((group) => {
                    if (!Array.isArray(group)) return;
                    group.forEach((test) => {
                        if (!test || test.user_id == null) return;
                        const userId = test.user_id;
                        if (!testMap[userId]) {
                            testMap[userId] = [];
                        }
                        testMap[userId].push(test);
                    });
                });

                const finalData = PersonalAbilityRecord.map(student => {
                    if (!student || student.user_id == null) {
                        return student;
                    }

                    return {
                        ...student,
                        testdata: testMap[student.user_id] || [] // 若无测评数据，返回空数组
                    };
                });
                this.TypeGrouping(finalData);

            } catch (error) {
                this.TypeGrouping([]);
            }
        },

        /**
         * 学生分级点评：象限统计 → 规则打分型 → 汇总表格与「积极占比」。
         * 接口字段（每人）：range_x、range_y、std_deviation_x/y、average_x/y 等；testdata 为与本页矩阵合并后的历次散点。
         */
        TypeGrouping(data) {
            const list = this.scaleAbilityStats(Array.isArray(data) ? data : []);
            // const THRESHOLD_X = 69.3;
            // const THRESHOLD_Y = 64.8;
            const THRESHOLD_X = 73.392;
            const THRESHOLD_Y = 69.645;
            this._typeGroupingStepCountQuadrants(list, THRESHOLD_X, THRESHOLD_Y);
            this._typeGroupingStepAssignLabels(list);
            this._typeGroupingStepAggregate(list);
        },

        /** 能力接口的区间、标准差与散点同一套年级系数。testdata 的 x、y 已在分组时乘过。 */
        scaleAbilityStats(students) {
            const grade = this.ParentData && this.ParentData.grade;
            const k0 = lookupGradeK0(this.factorMap, grade);
            if (k0 === 1) return students;
            const scale = (value) => {
                const n = Number(value);
                return Number.isFinite(n) ? n * k0 : value;
            };
            return students.map((student) => {
                if (!student) return student;
                return {
                    ...student,
                    range_x: scale(student.range_x),
                    range_y: scale(student.range_y),
                    std_deviation_x: scale(student.std_deviation_x),
                    std_deviation_y: scale(student.std_deviation_y),
                    average_x: scale(student.average_x),
                    average_y: scale(student.average_y),
                };
            });
        },

        /** 根据 testdata 中每个点的 (x,y) 统计落在四象限的次数 */
        _typeGroupingStepCountQuadrants(students, thresholdX, thresholdY) {
            students.forEach((student) => {
                let xiangxian1 = 0;
                let xiangxian2 = 0;
                let xiangxian3 = 0;
                let xiangxian4 = 0;
                let countall = 0;

                if (Array.isArray(student.testdata)) {
                    countall = student.testdata.length;
                    student.testdata.forEach((test) => {
                        const x = test.x;
                        const y = test.y;
                        if (typeof x !== 'number' || typeof y !== 'number') return;

                        if (x >= thresholdX && y >= thresholdY) xiangxian1++;
                        else if (x < thresholdX && y < thresholdY) xiangxian3++;
                        else if (x < thresholdX && y >= thresholdY) xiangxian2++;
                        else if (x >= thresholdX && y < thresholdY) xiangxian4++;
                    });
                }

                student.xiangxian1 = xiangxian1;
                student.xiangxian2 = xiangxian2;
                student.xiangxian3 = xiangxian3;
                student.xiangxian4 = xiangxian4;
                student.countall = countall;
                student.reportType = [];
            });
        },

        /**
         * 按固定优先级匹配类型（命中即 return，未命中归为重点型）。
         * 顺序：重点型 → 波动型 → 天赋型 → 双优型 → 进取型 → 稳健型 → 潜能型 → 默认重点型。
         */
        _typeGroupingStepAssignLabels(students) {
            students.forEach((student) => {
                if (
                    (student.xiangxian3 / student.countall >= 0.5) ||
                    (student.range_x < -5 && student.range_y < -5) ||
                    (student.range_y < -10 && student.xiangxian1 / student.countall < 0.6)
                ) {
                    student.reportType.push('重点型');
                    return;
                }

                if (student.std_deviation_x >= 8 || student.std_deviation_y >= 8) {
                    student.reportType.push('波动型');
                    return;
                }
                if ((student.xiangxian2 / student.countall >= 0.4) ||
                    (student.range_y > 5 && student.range_x <= 0)) {
                    student.reportType.push('天赋型');
                    return;
                }
                if (student.xiangxian1 / student.countall >= 0.6 && student.range_x >= 2 && student.range_y >= 2) {
                    student.reportType.push('双优型');
                    return;
                }
                if ((student.range_x >= 6 && student.range_y <= 3) ||
                    (student.xiangxian4 / student.countall >= 0.4 && student.range_x > 0)) {
                    student.reportType.push('进取型');
                    return;
                }
                if (student.range_x > 0 && student.range_y > 0 && student.std_deviation_x < 8 && student.std_deviation_y < 8) {
                    student.reportType.push('稳健型');
                    return;
                }
                if (
                    (student.xiangxian1 / student.countall > 0.2 && student.xiangxian3 / student.countall > 0.1) ||
                    (student.range_y < 0 && student.range_x >= 0) ||
                    (student.range_x < 0 && student.range_y >= 0) ||
                    (student.range_x < 0 && student.range_y < 0 && student.xiangxian1 / student.countall > 0.3)
                ) {
                    student.reportType.push('潜能型');
                    return;
                }
                student.reportType.push('重点型');
            });
        },

        /** 按类型分组、各类型人数、双优/稳健/进取占比（去重按 student.id） */
        _typeGroupingStepAggregate(data) {
            const allTypes = ['双优型', '稳健型', '重点型', '进取型', '潜能型', '波动型', '天赋型'];
            const groupedByType = {};
            allTypes.forEach((type) => { groupedByType[type] = []; });

            data.forEach((student) => {
                if (!Array.isArray(student.reportType)) return;
                student.reportType.forEach((type) => {
                    if (allTypes.includes(type)) groupedByType[type].push(student);
                });
            });

            this.formData = groupedByType;
            this.syTypeNum = groupedByType['双优型'].length;
            this.wdjTypeNum = groupedByType['稳健型'].length;
            this.nljTypeNum = groupedByType['进取型'].length;
            this.qnxTypeNum = groupedByType['潜能型'].length;
            this.bdTypeNum = groupedByType['波动型'].length;
            this.xgzTypeNum = groupedByType['重点型'].length;
            this.tfxTypeNum = groupedByType['天赋型'].length;

            const positiveTypes = ['双优型', '稳健型', '进取型'];
            const countedStudentIds = new Set();
            let positiveCount = 0;
            positiveTypes.forEach((type) => {
                groupedByType[type].forEach((student) => {
                    if (!countedStudentIds.has(student.id)) {
                        countedStudentIds.add(student.id);
                        positiveCount++;
                    }
                });
            });

            const totalCount = data.length;
            if (totalCount > 0) {
                this.isAllFormDataEmpty = false;
            }
            const positivePercentage = totalCount > 0
                ? ((positiveCount / totalCount) * 100).toFixed(2)
                : 0;
            this.positiveStudentCount = positiveCount;
            this.positiveStudentPercentage = positivePercentage;
        },

        /**
         * 按 Filtervalue 筛选各块展示数据；无筛选时用全量。
         * 参与情况表由父组件传入 ParticipateInStatistics，此处不处理。
         */
        LevelDistributionScreening() {
            console.log('this.Filtervalue子级', this.Filtervalue);
            if (!this.Filtervalue || this.Filtervalue.length === 0) {
                // 学校对比参与情况--------------------
                //参与情况表
                this.Participation_Data_G = this.ParticipationStatusStorage;
                this.Participation_GraphicalData_G = this.ParticipationStatusStorage;
                if (this.Participation_Data_G.length > 0) {
                    this.isEmpty = false;
                } else {
                    this.isEmpty = true;
                }
                // 学校对比参与情况--------------------
                // 等级分布情况--------------------
                this.Distribution_Data = this.originalDistributionData;
                this.Distribution_GraphicalData = this.originalDistributionData;
                // 等级分布情况--------------------
                //单项成绩对比情况-------------------
                this.Score_Data_G = this.IndividualEventResult;
                this.Score_GraphicalData_G = this.IndividualEventResult;
                this.Score_TableStructure_Type = this.Score_TableStructure_G.slice(1);
                this.ExcellentRateHelper(this.ExcellentRateOfEachClass);
                this.QuadrantDiagramData = this.groupDataByTestId(this.MatrixDistributionComparison);
                if (this.QuadrantDiagramData.length > 0) {
                    this.getStudentLevelRatioCompare();
                }
                return;
            }
            // 学校对比参与情况--------------------
            if (this.ParticipationStatusStorage && Array.isArray(this.ParticipationStatusStorage) && this.ParticipationStatusStorage.length > 0) {
                const Participate = this.ParticipationStatusStorage.filter(item => {
                    return this.Filtervalue.includes(item.keyvalue);
                });
                //参与情况表
                this.Participation_Data_G = Participate;
                console.log('this.Participation_Data_G',this.Participation_Data_G);
                
                this.Participation_GraphicalData_G = Participate;
                if (this.Participation_Data_G.length > 0) {
                    this.isEmpty = false;
                } else {
                    this.isEmpty = true;
                }
            }
            // 学校对比参与情况--------------------
            //等级分布情况--------------------
            if (this.originalDistributionData && Array.isArray(this.originalDistributionData) && this.originalDistributionData.length > 0) {
                const filteredData = this.originalDistributionData.filter((item) =>
                    this.Filtervalue.includes(item.keyvalue));
                this.Distribution_Data_G = filteredData;
                this.Distribution_GraphicalData_G = filteredData;
            }
            if (this.IndividualEventResult && Array.isArray(this.IndividualEventResult) && this.IndividualEventResult.length > 0) {
                const SingleItemData = this.Filtervalue
                    .map((keyvalue) => this.IndividualEventResult.find((item) => item.keyvalue === keyvalue))
                    .filter((item) => item !== undefined);
                this.Score_Data_G = SingleItemData;
                this.Score_GraphicalData_G = SingleItemData;
                this.Score_TableStructure_Type = this.Score_TableStructure_G.slice(1);
            }
            if (this.ExcellentRateOfEachClass && Array.isArray(this.ExcellentRateOfEachClass) && this.ExcellentRateOfEachClass.length > 0) {
                const ExcellentRate = this.ExcellentRateOfEachClass.filter((item) =>
                    this.Filtervalue.includes(item.keyvalue));
                this.ExcellentRateHelper(ExcellentRate);
            }
            if (this.MatrixDistributionComparison && Array.isArray(this.MatrixDistributionComparison) && this.MatrixDistributionComparison.length > 0) {
                const MatrixDistribution = this.MatrixDistributionComparison.filter((item) =>
                    this.Filtervalue.includes(item.keyvalue));
                this.QuadrantDiagramData = this.groupDataByTestId(MatrixDistribution);
                if (this.QuadrantDiagramData.length > 0) {
                    this.getStudentLevelRatioCompare();
                }
            }
        },
        /** 新窗口打开个人试卷页 */
        JumpToPersonalReport(id, name) {
            const routeUrl = this.$router.resolve({
                path: '/PersonalExamPaper',
                query: {
                    userId: id,
                    user_name: name,
                }
            })
            window.open(routeUrl.href, '_blank')
        },
        async UngradedStudentsRequest() {
            const url = `https://spark.deploy.lezhireading.com/statistics/static/results/owntypebyschoolnone4/${this.$route.query.schoolId}/${this.ParentData.term_id}`;
            try {
                const response = await axios.get(url, {
                    params: { noCache: Date.now() },
                    timeout: 50000,
                    headers: { 'Accept': 'application/json' }
                });
                const raw = response.data && response.data.data;
                this.UngradedStudents = Array.isArray(raw) ? raw : [];
            } catch (error) {
                console.error('UngradedStudents 请求失败:', error);
                this.UngradedStudents = [];
            }
        }

    },
    beforeDestroy() {
        this.destroyEchartsInstances();
    },
    mounted() {
        this.initAllMethods();
    },
}
</script>
<style scoped lang="less">
.GradeAnalysisSch_Compare {
    .GradeAnalysisSch_Compare_Title {
        margin-top: 45px;
        width: 100%;
        color: #01B68D;
        font-size: 25px;
        font-weight: bold;
        margin-bottom: 20px;
    }

    .Secondary_heading {
        display: flex;
        align-items: center;
        margin-top: 36px;
        // margin-right: 54px;
        // margin-left: 54px;

        .vertical_grain_icon {
            width: 4px;
            height: 18px;
            background: #01B68D;
            border-radius: 2px;
        }

        .title {
            font-size: 18px;
            color: #01B68D;
            margin-left: 10px;
            // font-weight: bold;
        }
    }

    .content {
        margin-top: 36px;

        .Participation_Chart {
            height: 450px;
            // border: 1px solid #000;
            margin-top: 30px;
        }

        .HeightIncrease {
            height: 500px !important;
        }

        .HeightIncreasegridStyle {
            text-align: center;
            font-size: 18px;
            margin: 60px 0;
            color: #00b487;
        }

        .QuadrantDiagram {
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            gap: 20px;
            margin-top: 36px;
            // margin-top: 160px;
            // margin-right: 54px;
            // margin-left: 54px;

            .grid-item {
                padding: 10px;
                border: 1px solid #eee;
                border-radius: 4px;
                height: 500px;

                .grid-item_title {
                    width: 100%;
                    text-align: center;
                    font-size: 16px;
                    font-weight: bold;
                    color: #01B58C;
                }
            }

            .HeightIncreasegrid {
                height: 600px !important;
                // border: 1px solid #000;
            }
        }

        .SummaryAndSuggestions {
            font-size: 18px;
            color: #333;
            font-weight: bold;
            margin-bottom: 12px;
        }

        .SuggestedCategory {
            font-size: 16px;
            color: #333;
            font-weight: bold;
            margin-top: 12px;
            margin-bottom: 12px;
        }

        .SummaryAndSuggestions_text {
            font-size: 16px;
            color: #666;
            line-height: 28px;
            text-indent: 2em;
            margin-top: 12px;
        }

        .ReviewForm {
            width: 100%;
            border-radius: 12px;
            // border: 1px solid #000;

            .ReviewForm_table {
                width: 100%;
                border-collapse: collapse;
                border-radius: 12px;
                border: 1px solid #000;

            }

            .ReviewForm_table th {
                height: 45px;
                border: 1px solid #ccc;
                padding: 8px;
                text-align: center;
                background-color: #f2fbf9;
                color: #01b58c;
                font-weight: bold;
                font-size: 16px;
            }

            .ReviewForm_table_type {
                width: 300px;
            }

            .ReviewForm_table_Person {
                width: 150px;
            }

            .ReviewForm_table td {
                height: 45px;
                border: 1px solid #ccc;
                padding: 8px;
                font-size: 16px;

                .List {
                    margin-right: 10px;
                }

                .List:hover {
                    color: #01b58c;
                    cursor: pointer;
                }

            }
        }

        .DimensionRating_table {
            border-collapse: collapse;
            border-spacing: 0;
            border-radius: 12px;
            width: 100%;
        }

        .DimensionRating_table th {
            height: 45px;
            border: 1px solid #e8e8e8;
            padding: 8px;
            text-align: center;
            background-color: #f2fbf9;
            color: #01b58c;
            font-weight: bold;
            font-size: 16px;
        }

        .DimensionRating_table td {
            height: 45px;
            border: 1px solid #e8e8e8;
            padding: 8px;
            font-size: 16px;
            text-align: center;

            .List {
                margin-right: 10px;
                color: #0070d9;
                text-decoration: underline;
            }
        }

        .UngradedStudents_table {
            .UngradedStudents_names {
                text-align: left;
                vertical-align: top;
                line-height: 1.6;
            }

            .UngradedStudents_names_inner {
                text-align: left;
            }

            .UngradedStudents_class_label {
                color: #333;
            }

            .UngradedStudents_name_link {
                color: #0070d9;
                text-decoration: underline;
                cursor: pointer;
            }

            .UngradedStudents_name_link:hover {
                color: #01b58c;
            }

            .UngradedStudents_empty {
                text-align: center;
                color: #999;
            }
        }
    }
}

.GradeAnalysisSch_Compare_Content {
    // border: 1px solid #000;
    margin-top: 80px;
}

.ClassificationTypeDescription {
    cursor: pointer;

    span {
        font-size: 16.5px !important;
    }

    .el-icon-info {
        margin-right: 5px;
    }

    &:hover .title {
        color: #01b58c;
    }
}

::v-deep .grade-classification-type-dialog {
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 16px 48px rgba(15, 74, 58, 0.14), 0 4px 12px rgba(0, 0, 0, 0.06);
    display: flex;
    flex-direction: column;
    max-height: calc(100vh - 32px);

    .el-dialog__header {
        padding: 20px 24px 18px;
        margin: 0;
        background: linear-gradient(135deg, #f0faf8 0%, #ffffff 55%);
        border-bottom: 1px solid rgba(1, 181, 140, 0.15);

        .el-dialog__title {
            font-size: 17px;
            font-weight: 600;
            color: #1a4d3f;
            letter-spacing: 0.02em;
        }

        .el-dialog__headerbtn .el-dialog__close {
            color: #7a9d94;
            font-size: 18px;

            &:hover {
                color: #01b58c;
            }
        }
    }

    .el-dialog__body {
        flex: 1 1 auto;
        min-height: 0;
        overflow-y: auto;
        padding: 20px 22px 24px;
        background: #f6faf9;
    }

    .classification-type-desc-list {
        margin: 0;
        padding: 0;
        list-style: none;
        counter-reset: classification-step;

        li {
            position: relative;
            counter-increment: classification-step;
            margin-bottom: 10px;
            padding: 14px 14px 14px 44px;
            line-height: 1.7;
            font-size: 14px;
            color: #3d4a47;
            text-align: left;
            background: #fff;
            border: 1px solid rgba(1, 181, 140, 0.12);
            border-radius: 10px;
            box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
            transition: border-color 0.2s ease, box-shadow 0.2s ease;

            &::before {
                content: counter(classification-step);
                position: absolute;
                left: 12px;
                top: 13px;
                width: 24px;
                height: 24px;
                line-height: 24px;
                text-align: center;
                font-size: 12px;
                font-weight: 600;
                color: #fff;
                background: linear-gradient(145deg, #02c99d 0%, #01a67f 100%);
                border-radius: 50%;
                box-shadow: 0 2px 6px rgba(1, 181, 140, 0.35);
            }

            &:last-child {
                margin-bottom: 0;
            }

            &:hover {
                border-color: rgba(1, 181, 140, 0.28);
                box-shadow: 0 4px 14px rgba(1, 181, 140, 0.1);
            }

            strong {
                color: #0d6b56;
                font-weight: 600;
            }
        }
    }

    .classification-type-desc-note {
        margin: 14px 0 0;
        padding: 12px 14px;
        line-height: 1.7;
        font-size: 13px;
        color: #6b7a76;
        text-align: left;
        background: #fff;
        border: 1px dashed rgba(1, 181, 140, 0.28);
        border-radius: 8px;
    }
}
</style>

<style lang="less">
/* append-to-body 时遮罩在组件外，单独居中（与 scoped 互补） */
.el-dialog__wrapper:has(> .el-dialog.grade-classification-type-dialog) {
    align-items: center;
    display: flex;
    justify-content: center;

    .el-dialog.grade-classification-type-dialog {
        margin-top: 0 !important;
    }
}
</style>